export default {
  CREATE_BACKUP_KEY: 'shelvery:create_backup',
  SERVICES: [
    'EBS',
    'RDS',
    'AMI',
    'RedShift',
    'RDSCluster',
    'DocumentDB'
  ],
  CONFIG_KEYS: [
    'shelvery:create_backup',
    'shelvery:config:shelvery_keep_daily_backups',
    'shelvery:config:shelvery_keep_weekly_backups',
    'shelvery:config:shelvery_keep_monthly_backups',
    'shelvery:config:shelvery_keep_yearly_backups',
    'shelvery:config:shelvery_custom_retention_types',
    'shelvery:config:shelvery_current_retention_type',
    'shelvery:config:shelvery_dr_regions',
    'shelvery:config:shelvery_wait_snapshot_timeout',
    'shelvery:config:shelvery_share_aws_account_ids',
    'shelvery:config:shelvery_source_aws_account_ids',
    'shelvery:config:shelvery_bucket_name_template',
    'shelvery:config:shelvery_rds_backup_mode',
    'shelvery:config:shelvery_redshift_backup_mode',
    'shelvery:config:shelvery_lambda_max_wait_iterations',
    'shelvery:config:shelvery_select_entity',
    'shelvery:config:shelvery_sns_topic',
    'shelvery:config:shelvery_error_sns_topic',
    'shelvery:config:shelvery_copy_resource_tags',
    'shelvery:config:shelvery_exluded_resource_tag_keys',
    'shelvery:config:shelvery_sqs_queue_url',
    'shelvery:config:shelvery_sqs_queue_wait_period',
    'shelvery:config:shelvery_ignore_invalid_resource_state'
  ],
  IGNORE_RESOURCE_KEYS: [
    'shelvery_config',
    'vgt_id',
    'originalIndex'
  ],
  TRUE_VALUES: [
    'true',
    'True',
    true,
    '1',
    1
  ],
  FALSE_VALUES: [
    'false',
    'False',
    false,
    '0',
    0
  ]
}



// WEBPACK FOOTER //
// ./src/constants/shelvery.js